import { connect } from 'react-redux'

import {
  addRentalLedger,
  fetchRentalHistoryRatingCategories,
  fetchRentalHistoryReview,
  removeRentalLedger,
  rentalHistoryCreateTenantRating,
  rentalHistoryDecline,
  rentalHistoryFinalize,
  rentalHistoryUpdateTenantRating,
  setRentalHistorySecret,
} from 'app/bond_cover/bond_cover_actions'
import RatingForm from 'app/bond_cover/renters/history/bc_rating_form_container'

const mapStateToProps = ({ bondCover, session }) => ({
  RentalHistory: bondCover.rentalHistoryReview.RentalHistory,
  ratingCategories: bondCover.ratingCategories,
  tenantRating: bondCover.rentalHistoryReview.Rating,
  renter: bondCover.rentalHistoryReview.Renter,
  message: bondCover.rentalHistoryReview.Message,
  isHistoryRating: true,
  currentUser: session.currentUser,
  secretGUID: bondCover.secretGUID,
  error: bondCover.error,
  showRentalLedgerSpinner: bondCover.showRentalLedgerSpinner,
  rentalHistoryReview: bondCover.rentalHistoryReview,
})

const mapDispatchToProps = (dispatch) => ({
  setRentalHistorySecret: (secretGUID) =>
    dispatch(setRentalHistorySecret(secretGUID)),
  fetchRentalHistoryReview: (referenceId) =>
    dispatch(fetchRentalHistoryReview(referenceId)),
  fetchRentalHistoryRatingCategories: () =>
    dispatch(fetchRentalHistoryRatingCategories()),
  createTenantRating: (referenceId, payload) =>
    dispatch(rentalHistoryCreateTenantRating(referenceId, payload)),
  updateTenantRating: (referenceId, payload) =>
    dispatch(rentalHistoryUpdateTenantRating(referenceId, payload)),
  proceed: (referenceId, comment) =>
    dispatch(rentalHistoryFinalize(referenceId, comment)),
  decline: (referenceId, payload) =>
    dispatch(rentalHistoryDecline(referenceId, payload)),
  addRentalLedger: (historyGUID, secretGUID, documentType) =>
    dispatch(addRentalLedger(historyGUID, secretGUID, documentType)),
  removeRentalLedger: (historyGUID, secretGUID, ledgerGUID) =>
    dispatch(removeRentalLedger(historyGUID, secretGUID, ledgerGUID)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RatingForm)
